import React from "react";

interface OrderHeaderProps {
  userInfo: {
    firstName: string;
    email: string;
  } | undefined;
  editingOrder: {
    id: number;
    status: string;
    address_id: string;
    vat: number;
    grand_total: number;
    total_price: number;
    date_ordered: string | null;
    requested_ship_date: string;
    reference_number: string;
    user_id: number;
    receipt_url: string | null;
  } | null;
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    day: "numeric",
    year: "numeric",
    month: "long",
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
};

const OrderHeader: React.FC<OrderHeaderProps> = ({ userInfo, editingOrder }) => {
  return (
    <div className="mt-4">
      <header className="bg-white shadow-md rounded-lg p-6">
        <div className="max-w-7xl mx-auto grid grid-cols-2 gap-4">
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              {userInfo?.firstName}
            </h2>
            <p className="text-sm text-gray-500">
              {userInfo?.email}
            </p>
          </div>

          <div className="text-right">
            <h2 className="text-lg font-bold text-gray-800">
              Order Reference: {editingOrder?.reference_number}
            </h2>
            {editingOrder?.requested_ship_date && (
              <p className="text-sm text-gray-500">
                {formatDate(editingOrder?.requested_ship_date)}
              </p>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default OrderHeader;